import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/Button";
import { Colors } from "../../config/Constants";
import { decryptItem } from "../../utils";
const nextIcon = require("../../assets/images/next_icon.png");

const NotFound = () => {
  const navigate = useNavigate();
  const [buttonLabel, setButtonLabel] = useState<string>("");
  useEffect(() => {
    if (localStorage.getItem("token")) setButtonLabel("Back to Home");
    else setButtonLabel("Back to Login");
  }, []);
  const handleSubmit = () => {
    let { user } = decryptItem();
    if (localStorage.getItem("token"))
      navigate(
        `/admin${
          Number(user) === 1
            ? "/dashboard"
            : Number(user) === 2
            ? "/physical-card"
            : Number(user) === 3
            ? "/dispute"
            : "/push-notification"
        }`
      );
    else navigate("/auth/login");
  };
  return (
    <NotFoundContainer>
      <NotFoundInner>
        <Img404 src={require("../../assets/images/img_404.png")} />
        <NotFoundHeader>Oops, Page Not Found!</NotFoundHeader>
        <SubWrapper>
          <NotFoundSub>
            We're sorry, the page you requested could not be found
          </NotFoundSub>
        </SubWrapper>
        <Button
          label={buttonLabel}
          variant="filled"
          color={Colors.solidRed}
          endIcon={nextIcon}
          onClick={() => handleSubmit()}
        />
      </NotFoundInner>
    </NotFoundContainer>
  );
};

export default NotFound;

const NotFoundContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  @media only screen and (max-width: 768px) {
    padding: 1rem;
  }
`;
const NotFoundInner = styled.div`
  disply: flex;
  flex-direction: column;
  text-align: center;
`;
const Img404 = styled.img`
  width: 80%;
`;
const NotFoundHeader = styled.div`
  font-family: "Poppins-Bold";
  font-size: 40px;
  color: #000000;
  margin-top: 80px;
`;
const SubWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0 40px;
`;
const NotFoundSub = styled.div`
  font-family: "Poppins-Book";
  font-size: 20px;
  color: #262626;
  width: 350px;
`;
